import { render, staticRenderFns } from "./ValuePopup.vue?vue&type=template&id=458d2dc1&scoped=true"
import script from "./ValuePopup.vue?vue&type=script&lang=js"
export * from "./ValuePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458d2dc1",
  null
  
)

export default component.exports